export default function formatInputDate(date) {
  let newDay = new Date(date).getUTCDate();
  let newMonth = new Date(date).getUTCMonth() + 1;
  let newYear = new Date(date).getFullYear();
  return `${newYear}-${newMonth}-${newDay}`;
}